import { ColorPickerAnt } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { useTranslation } from "react-i18next"

const CardColorDocumentoSetting = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const isSelectedColor = (color: string) => {
    return values.config.colorSelected === color
  }
  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-mb-10'>
      <p className='tw-text-left tw-mb-3'>
        {t("crear.facturaRec.principalColorLabel")}
      </p>
      <div className='tw-flex tw-flex-row'>
        {values.config.userColors?.map((color: string) => {
          return (
            <div
              className='tw-mr-3 !tw-w-9 !tw-h-9 !tw-rounded-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
              style={{
                backgroundColor: color,
              }}
              key={`${color}`}
              onClick={() => {
                setFieldValue("config.colorSelected", color)
                localStorage.setItem("documento_last_color_used", color)
              }}
            >
              {isSelectedColor(color) ? (
                <FontAwesomeIcon
                  icon={["fal", "check"]}
                  className='tw-w-3.5 tw-h-3.5 tw-text-simple-10'
                />
              ) : (
                <></>
              )}
            </div>
          )
        })}

        <div className=''>
          <ColorPickerAnt
            value={values.config.extraColor}
            format='hex'
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(_: $TSMigrationFixMe, ex: string) => {
              setFieldValue("config.extraColor", ex)
              setFieldValue("config.colorSelected", ex)
              localStorage.setItem("documento_last_color_used", ex)
            }}
          >
            <span
              className='tw-mr-3 !tw-w-9 !tw-h-9 !tw-rounded-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
              style={{ backgroundColor: values.config.extraColor }}
            >
              <FontAwesomeIcon
                icon={["fal", "plus"]}
                className='tw-w-3.5 tw-h-3.5 tw-text-simple-10'
              />
            </span>
          </ColorPickerAnt>
        </div>
      </div>
    </div>
  )
}

export default CardColorDocumentoSetting
